module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('div', {
    staticClass: "title-acknowPage"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466804319_toc01#toctitle2",
      "id": "title2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("I wish to thank my wife, Eleanor, for her many hours proofreading the manuscript. Without her painstaking work, the manuscript would never have gotten past the rough-notes stage. I would like also to cite my son, Bob, who typed much of the initial draft, and Mike Friedman, who provided new concepts and assistance.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee335890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466804319_ack01.vue
// module id = 69
// module chunks = 0